import React from "react";
import OrderDTO from "@/dto/order/OrderDTO";
import { ShipValidationRule, ShipValidationRuleKey } from "../type";
import { buildValidationFailedResult, buildValidationSuccessfulResult } from "../util";
import { Modal } from "antd";
import GlobalStore from "@/store";
import { DisabledPendingShipmentRefundingShipShopTypes } from "@/utils/ShopUtils";

export default async function validateDouDianRefundingOrder(
    orders: OrderDTO[],
    rule: ShipValidationRule,
    globalStore: typeof GlobalStore,
) {
    const config = rule[ShipValidationRuleKey.checkDouDianRefundingOrder];
    if (!config) return buildValidationSuccessfulResult(orders);

    const { shopMapping } = globalStore;

    const hasDouDianNotShippableOrder = orders.some(
        ({ shopId, isRefunding }) =>
            isRefunding && DisabledPendingShipmentRefundingShipShopTypes.includes(shopMapping.get(shopId)?.type),
    );

    if (hasDouDianNotShippableOrder) {
        const msg = "退款中的抖店订单请先前往抖店后台处理售后，再回来进行发货。如急需发货建议前往后台发货";

        if (config === true || config.needModal) {
            Modal.error({
                title: "发货失败",
                content: <p className="error">{msg}</p>,
            });
        }

        return buildValidationFailedResult(msg);
    }

    return buildValidationSuccessfulResult(orders);
}
